import { initMap, equalCols, getCookie } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const contactWidget = {
        isLoading: false,
        init() {
            $(document).on('click', '.submit-contact-form', this, this.send);
            $(document).on('click', '.submit-science-community-leads-form', this, this.sendScienceCommunityLeads);
            
            $(document).on('click', '.contact_file_btn', function(e) {
                e.preventDefault();
                var id = $(this).data('id');

                $('#'+id).trigger('click');
            });

            $(document).on('change', '.contact_file_input', function(element) {
                var fileName = $(this).val().split('\\').pop();
                console.log(fileName);
                if (fileName == '') {
                    fileName = $('.contact_file_btn').data('text');
                }
                $('.contact_file_btn').find('span').text(fileName);
            });
        },
		send(event) {
			const _this = event.data;
			event.preventDefault();

			let mid = $(this).data('mid');

			if (_this.isLoading) {
                return false;
            }

			$('.contact-form-msgs-holder').hide();
            $('#contact-form-' + mid).find('.form-control').removeClass('is-invalid');
            $('#contact-form-' + mid).find('.form-check-input').removeClass('is-invalid');

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

            var file = document.getElementById("contact_file_" + mid).files[0];

            var formdata = new FormData();
            formdata.append("module_id", mid);
            formdata.append("type_id", $(this).data('type'));
            formdata.append("source", $(this).data('source'));
            formdata.append("name", $('#contact_name_' + mid).val());
            formdata.append("email", $('#contact_email_' + mid).val());
            formdata.append("phone", $('#contact_phone_' + mid).val());
            formdata.append("studies", $('#contact_studies_' + mid).val());
            formdata.append("experience", $('#contact_experience_' + mid).val());
            if ($(this).data('type') == 1) {
                formdata.append("department", $('#contact_department_' + mid).val());
            } else {
                formdata.append("department", $('#contact_department_' + mid + ' option:selected').val());
            }
            formdata.append("file", (file?file:''));
            //formdata.append("message", $('#contact_message_' + mid).val());
            formdata.append("terms-and-condition", ($('#contact_terms-and-condition_' + mid).is(":checked")?1:''));
            formdata.append("_token", $('#_token_contact_form_' + mid).val());
			$.ajax({
	            type: "POST",
	            url: baseURL + '/contact/send',
	            data: formdata,
                processData: false,
                contentType: false,
	            success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
						var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                if (errorKey == 'department') {
                                    continue;
                                }
                                $('#contact_' + errorKey + '_' + mid).addClass('is-invalid');
                                errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                            //$("#"+errorKey).closest('.form-group').addClass('has-error');
                            //$("#"+errorKey).css('border', '1px solid red');
                        }
                        //errorHtml
                        errorHtml;
                        $('#contact-form-error-msg').html(errorHtml);
                        $('#contact-form-error-msg').fadeIn();
                        //$('#contact-form-error-msg').delay(10000).fadeOut();
                        //errors
                        return false;
                    }

					if (response.status == 1) {
						$('#contact-form-' + mid).find('.form-control').val('');
						$('#contact_terms-and-condition_' + mid).prop('checked', false);

						Swal.fire({
							//icon: 'success',
							//title: 'Success!',
							html: response.message
						});

						if (cookies_advertisement == 1) {
							//gtag('event', 'conversion', {'send_to': ''});
						}

						if (cookies_advertisement == 1 || cookies_social == 1) {
							//fbq('track', 'Lead');
						}

						return false;
					}

					if (response.status == 2) {
						$('#contact-form-error-msg').html(response.errors);
                        $('#contact-form-error-msg').fadeIn();
                        //$('#contact-form-error-msg').delay(10000).fadeOut();
                    }

					if (response.status == 3) {
						$('#contact-form-error-msg').html(response.errors);
                        $('#contact-form-error-msg').fadeIn();
                        //$('#contact-form-error-msg').delay(10000).fadeOut();
                    }
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
		},
		sendScienceCommunityLeads(event) {
			const _this = event.data;
			event.preventDefault();

			let mid = $(this).data('mid');
			let type = $(this).data('type');

			if (_this.isLoading) {
                return false;
            }

			$('.contact-form-msgs-holder').hide();
            $('#contact-form-' + mid).find('.form-control').removeClass('is-invalid');
            $('#contact-form-' + mid).find('.form-check-input').removeClass('is-invalid');

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

            var formdata = new FormData();
            formdata.append("module_id", mid);
            formdata.append("type", type);
            formdata.append("source", $(this).data('source'));
            formdata.append("name", $('#contact_name_' + mid).val());
            formdata.append("email", $('#contact_email_' + mid).val());
            formdata.append("phone", $('#contact_phone_' + mid).val());
            formdata.append("city", $('#contact_city_' + mid).val());
            formdata.append("education", $('#contact_education_' + mid).val());
            formdata.append("graduation_year", $('#contact_graduation_year_' + mid).val());
            formdata.append("linkedin", $('#contact_linkedin_' + mid).val());
            formdata.append("terms-and-condition", ($('#contact_terms-and-condition_' + mid).is(":checked")?1:''));
            formdata.append("newsletter", ($('#contact_newsletter_' + mid).is(":checked")?1:''));
            formdata.append("_token", $('#_token_contact_form_' + mid).val());
			$.ajax({
	            type: "POST",
	            url: baseURL + '/contact/send',
	            data: formdata,
                processData: false,
                contentType: false,
	            success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
						var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                if (errorKey == 'department') {
                                    continue;
                                }
                                $('#contact_' + errorKey + '_' + mid).addClass('is-invalid');
                                errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                            //$("#"+errorKey).closest('.form-group').addClass('has-error');
                            //$("#"+errorKey).css('border', '1px solid red');
                        }
                        //errorHtml
                        errorHtml;
                        $('#contact-form-error-msg').html(errorHtml);
                        $('#contact-form-error-msg').fadeIn();
                        //$('#contact-form-error-msg').delay(10000).fadeOut();
                        //errors
                        return false;
                    }

					if (response.status == 1) {
						$('#contact-form-' + mid).find('.form-control').val('');
						$('#contact_terms-and-condition_' + mid).prop('checked', false);

						Swal.fire({
							//icon: 'success',
							//title: 'Success!',
							html: response.message
						});

						if (cookies_advertisement == 1) {
							//gtag('event', 'conversion', {'send_to': ''});
						}

						if (cookies_advertisement == 1 || cookies_social == 1) {
							//fbq('track', 'Lead');
						}

						return false;
					}

					if (response.status == 2) {
						$('#contact-form-error-msg').html(response.errors);
                        $('#contact-form-error-msg').fadeIn();
                        //$('#contact-form-error-msg').delay(10000).fadeOut();
                    }

					if (response.status == 3) {
						$('#contact-form-error-msg').html(response.errors);
                        $('#contact-form-error-msg').fadeIn();
                        //$('#contact-form-error-msg').delay(10000).fadeOut();
                    }
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
		}
    };

    if ($('.form-contact-home').length) {
        contactWidget.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/contact.js